import { Box, Button, Chip, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { FieldValue } from '../../../../../../types/QueryBuilder';
import { DUAL_LIST_SIDES, DualListSide, SIDE_COLOR } from './dualListSides';

interface DualListOptionRowProps {
    option: FieldValue;
    membership: DualListSide | null;
    labels: Record<DualListSide, string>;
    onAdd: (side: DualListSide) => void;
    onRemove: (side: DualListSide) => void;
}

const CHIP_COLOR: Record<DualListSide, 'success' | 'error'> = { include: 'success', exclude: 'error' };

function DualListOptionRow({ option, membership, labels, onAdd, onRemove }: DualListOptionRowProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1,
                px: 1,
                py: 0.5,
                minHeight: 40,
                borderBottom: '1px solid',
                borderColor: 'divider',
                '&:last-of-type': { borderBottom: 'none' },
            }}
        >
            <Typography
                variant="body2"
                sx={{ color: 'text.primary', flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                title={option.label}
            >
                {option.label}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', gap: 0.5, flexShrink: 0, minWidth: { xs: 0, sm: 280 } }}>
                {membership ? (
                    <Chip size="small" color={CHIP_COLOR[membership]} label={labels[membership]} onDelete={() => onRemove(membership)} />
                ) : (
                    DUAL_LIST_SIDES.map(side => (
                        <Button
                            key={side}
                            size="small"
                            startIcon={<AddIcon fontSize="small" />}
                            onClick={() => onAdd(side)}
                            sx={{ textTransform: 'none', color: SIDE_COLOR[side], whiteSpace: 'nowrap' }}
                        >
                            {labels[side]}
                        </Button>
                    ))
                )}
            </Box>
        </Box>
    );
}

export default DualListOptionRow;
